module.exports = __webpack_public_path__ + "img/cd1.e25ba723.png";